import { render } from "./GroupName.vue?vue&type=template&id=070da1c6&scoped=true"
import script from "./GroupName.vue?vue&type=script&lang=js"
export * from "./GroupName.vue?vue&type=script&lang=js"

import "./GroupName.vue?vue&type=style&index=0&id=070da1c6&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070da1c6"]])

export default __exports__